var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeusersStrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2988_7403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 15C25.1645 14.9991 26.3131 15.2698 27.3547 15.7906C28.3963 16.3114 29.302 17.0679 30 18",
    stroke: "#7043FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 18C2.698 17.0679 3.60375 16.3114 4.6453 15.7906C5.68686 15.2698 6.83551 14.9991 8 15",
    stroke: "#7043FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 23C18.7614 23 21 20.7614 21 18C21 15.2386 18.7614 13 16 13C13.2386 13 11 15.2386 11 18C11 20.7614 13.2386 23 16 23Z",
    stroke: "#7043FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 27C9.71786 25.7818 10.7412 24.772 11.9689 24.0705C13.1965 23.369 14.586 23 16 23C17.414 23 18.8035 23.369 20.0311 24.0705C21.2588 24.772 22.2821 25.7818 23 27",
    stroke: "#7043FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.125 10C20.312 9.27571 20.6984 8.61836 21.2402 8.10263C21.7821 7.58689 22.4577 7.23343 23.1903 7.08239C23.923 6.93135 24.6833 6.98877 25.3849 7.24815C26.0866 7.50752 26.7014 7.95845 27.1596 8.54971C27.6179 9.14098 27.9011 9.8489 27.9772 10.5931C28.0533 11.3372 27.9192 12.0878 27.5902 12.7596C27.2611 13.4314 26.7502 13.9974 26.1156 14.3935C25.481 14.7895 24.748 14.9996 24 15",
    stroke: "#7043FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99994 15C7.25189 14.9996 6.51894 14.7895 5.88432 14.3935C5.2497 13.9974 4.73884 13.4314 4.40977 12.7596C4.08071 12.0878 3.94661 11.3372 4.02271 10.5931C4.09881 9.8489 4.38206 9.14098 4.84029 8.54971C5.29853 7.95845 5.91338 7.50752 6.61502 7.24815C7.31667 6.98877 8.07698 6.93135 8.80962 7.08239C9.54226 7.23343 10.2179 7.58689 10.7597 8.10263C11.3016 8.61836 11.6879 9.27571 11.8749 10",
    stroke: "#7043FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2988_7403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeusersStrong);
export default __webpack_public_path__ + "static/media/threeusers_strong.005b5fed2ea26a76198cadcbeb9a574c.svg";
export { ForwardRef as ReactComponent };